exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "queries h6{float:right;display:inline-block;margin-right:10px}queries h6:first-of-type{margin-right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/common/reports/queries/queries.styl
// module id = 79
// module chunks = 1